const classNames = (...classNames: (string | undefined | false)[]): string => {
  return classNames
    .filter((className) => className && className.trim() !== '')
    .join(' ')
    .trim()
}

export default classNames
